import { createContext } from "react";

interface IImageUploadListener {
    (): void;
}

export class ImageUploadUpdater {
    private listeners: Record<number, IImageUploadListener[]> = {};

    public subscribe(id: number, callback: () => void) {
        if (!this.listeners[id]) {
            this.listeners[id] = [];
        }

        this.listeners[id].push(callback);

        return () => {
            this.listeners[id] = this.listeners[id].filter((listener) => listener !== callback);
        };
    }

    public notify(id: number) {
        if (this.listeners[id]) {
            this.listeners[id].forEach((callback) => callback());
        }
    }
}

export const ImageUploadUpdaterContext = createContext<ImageUploadUpdater>(new ImageUploadUpdater());

